const MyBankDetails = () => {
    return (
        <>
            <section className="user-dashboard-section section-b-space">
                <div className="container-fluid-lg">
                    <div className="row">
                        <div className="col-xxl-12 col-lg-12">
                            <div className="row g-4">
                                <div className="col-xxl-12">
                                <div className="form-floating theme-form-floating">
                                            <input
                                                type="number"
                                                className="form-control"
                                                id="bank_ac_no"
                                                defaultValue="vicki.pope@gmail.com"
                                            />
                                            <label htmlFor="bank_ac_no">Bank A/c no</label>
                                        </div>
                                </div>
                                <div className="col-xxl-6">
                                <div className="form-floating theme-form-floating">
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="bank_name"
                                                defaultValue="Jack Jennas"
                                            />
                                            <label htmlFor="bank_name">Bank Name</label>
                                        </div>
                                </div>
                                <div className="col-xxl-6">
                                        <div className="form-floating theme-form-floating">
                                            <input
                                                className="form-control"
                                                type="text"
                                                defaultValue={4567891234}
                                                name="bank_ifsc"
                                                id="bank_ifsc"
                                                maxLength={10}
                                            />
                                            <label htmlFor="bank_ifsc">Bank IFSC</label>
                                        </div>
                                </div>                             
                                <button className="btn btn-md bg-theme text-white mt-3 float-end w-100">Save</button>
                                                
                            </div>

                        </div>
                    </div>
                </div>
            </section>
        </>)
}

export default MyBankDetails;